import { Text, View } from '@react-pdf/renderer';

const Skills = ({ styles, data = [], headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<View style={styles.headingBox}>
				<Text style={styles.heading}>{headerTitle}</Text>
			</View>

			<View style={styles.skills}>
				{data?.map((res: any, index: any) => (
					<View key={`skills-${index}`} style={styles.skillsBox}>
						<Text style={styles.skillsText}>{res?.title}</Text>
					</View>
				))}
			</View>
		</View>
	);
};

export default Skills;
